import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { StyledButton, StyledPopper } from './StyledComponents'; // Import styled components from a separate file
import { EditIcon } from 'components/icons';
import AutocompleteComponent from './AutocompleteComponent';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Box } from '@mui/material';
import { getCompanies } from 'api';

interface Company {
	Id: string;
	Name: string;
}

interface FloatingCompanySelectorProps {
	// Define your props here
	updateCompanyInFilter: (companyId: number | null) => void;
}

export default function FloatingCompanySelector(
	props: FloatingCompanySelectorProps,
) {
	const { updateCompanyInFilter } = props;
	const [companies, setCompanies] = React.useState<Company[]>([]);
	const [loadingCompanies, setLoadingCompanies] =
		React.useState<boolean>(false);
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const [value, setValue] = React.useState<Company | null>(null);
	const [pendingValue, setPendingValue] = React.useState<Company | null>(
		null,
	);
	const theme = useTheme();

	React.useEffect(() => {
		const getAllCompanies = async () => {
			setLoadingCompanies(true);
			const result = await getCompanies();
			setCompanies(result);
			setLoadingCompanies(false);
		};
		getAllCompanies();
	}, []);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setPendingValue(value);
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setValue(pendingValue);
		updateCompanyInFilter(
			pendingValue?.Id ? parseInt(pendingValue.Id) : null,
		);
		anchorEl?.focus();
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'employee-label' : undefined;

	return (
		<Box>
			<StyledButton
				disableRipple
				aria-describedby={id}
				onClick={handleClick}
			>
				<span>{value?.Name || 'All Companies'}&nbsp;</span>
				<EditIcon />
			</StyledButton>
			<StyledPopper
				id={id}
				open={open}
				anchorEl={anchorEl}
				placement="bottom-start"
			>
				<ClickAwayListener onClickAway={handleClose}>
					<div>
						<AutocompleteComponent
							pendingValue={pendingValue}
							setPendingValue={setPendingValue}
							handleClose={handleClose}
							options={companies}
							optionLabelAttribute="Name"
							loadingOptions={loadingCompanies}
							theme={theme}
						/>
					</div>
				</ClickAwayListener>
			</StyledPopper>
		</Box>
	);
}
